import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { FolderOutlined, LinkOutlined } from '@ant-design/icons';
import { DirectoryValue } from '../../types/directory';
import { DirectoryValuesInput } from './DirectoryValuesInput';

interface DirectoryFormProps {
  initialValues?: {
    name: string;
    slug: string;
    values: DirectoryValue[];
  };
  onSubmit: (values: { name: string; slug: string; values: DirectoryValue[] }) => Promise<void>;
  submitButtonText: string;
  error: string | null;
  loading: boolean;
}

const DirectoryForm: React.FC<DirectoryFormProps> = ({
  initialValues,
  onSubmit,
  submitButtonText,
  error,
  loading,
}) => {
  const [values, setValues] = useState<DirectoryValue[]>(initialValues?.values || []);

  const onFinish = async (formValues: { name: string; slug: string }) => {
    await onSubmit({
      ...formValues,
      values,
    });
  };

  return (
    <>
      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: '1rem' }} />}

      <Form
        name="directory-form"
        onFinish={onFinish}
        layout="vertical"
        initialValues={initialValues}>
        <Form.Item
          name="name"
          rules={[{ required: true, message: 'Please input directory name.' }]}>
          <Input prefix={<FolderOutlined />} placeholder="Name" />
        </Form.Item>

        <Form.Item
          name="slug"
          rules={[{ required: true, message: 'Please input directory slug.' }]}>
          <Input prefix={<LinkOutlined />} placeholder="Slug" />
        </Form.Item>

        <Form.Item name="values">
          <DirectoryValuesInput values={values} onChange={setValues} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {submitButtonText}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default DirectoryForm;
